import React, { useEffect, useContext } from 'react';

import {
    Hidden,
    LinearProgress,
    Grid
} from '@material-ui/core';

import { TablesProvider, TablesContext, TableValueType } from './TablesContext';
import { NavContext } from '../../../contexts';

import {
    TableList,
    TableSelector,
    TableValueList
} from './components';

import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme) => ({
    root: {
    },
    progress: {
        marginBottom: theme.spacing(2)
    }
}));

const PageContent = (props) => {
    const { addBreadcrumbToken } = useContext(NavContext);
    const classes = useStyles();

    const {
        state,
        isLoadingTableDefs,
        getTableDefinitions,
        isLoadingTableValues,
        getTableValues
    } = useContext(TablesContext);

    useEffect(() => {
        addBreadcrumbToken("Dimensions");
        getTableDefinitions(TableValueType.Local);
    }, []);

    useEffect(() => {
        if (state.selectedTableIndex !== -1)
            getTableValues(state.selectedTableIndex);
    }, [state.selectedTableIndex]);

    return (
        <>
            {
                isLoadingTableDefs &&
                <LinearProgress color="primary" className={classes.progress} />
            }
            
            {
                state.tables.length > 0 &&
                <Grid container spacing={2}>
                    <Hidden mdDown>
                        <Grid item lg={3} xg={4} >
                            <TableList tableValueType={TableValueType.Local} />
                        </Grid>
                        <Grid item lg={9} xg={8} >
                            <TableValueList tableValueType={TableValueType.Local} />
                        </Grid>
                    </Hidden>
                    <Hidden lgUp>
                        <Grid item xs={12}>
                            <TableSelector tableValueType={TableValueType.Local} />
                        </Grid>
                        <Grid item xs={12}>
                            <TableValueList tableValueType={TableValueType.Local} />
                        </Grid>
                    </Hidden>
                </Grid>
            }
        </>
    );
}

export const DimensionPage = (props) => {
    return (
        <TablesProvider>
            <PageContent />
        </TablesProvider>
    );
}